import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import {
	getOthersLocalUserDetails,
	updateUserAccounts,
} from '../../../redux/actions';

/*Dialogs*/
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';

class UpdateUser extends Component {

	constructor(props) {
        super(props);
        this.state = {
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
			showEmailUpdateConfirmationDialog: false,

			errorMessage: '',
			showForm: false,
			searchUserForm: {
				params: {
					userName: '',
				},
				errors: {
					userNameError: '',
				}
			},
			userDetails: {
				params: {
					firstName: '',
					lastName: '',
					emailId: '',
				},
				errors: {
					emailIdError: '',
				}
			}
        }
    }

	componentWillMount() {
		if(!this.props.isEmployeeHasAccessTo('Update User')) {
			browserHistory.push("/home");
		}
	}

	updateParams(formName, event) {
		//Reseting Errors on change
		const self = this;
		self.setState({
			[formName]: {
				...self.state[formName],
				params: {
					...self.state[formName].params,
					[event.target.name]: event.target.value
				},
				errors: {
					...self.state[formName].errors,
					[event.target.name+'Error']: ''
				},
			}
		});
	}

	validateEmail(emails) {
        var re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/;
        emails = emails.split(',');
        for (var i = 0; i < emails.length; i++) {
            if(emails[i].trim() !== "" && !emails[i].trim().match(re)) {
                return false;
            }
        }
        return true;
    }

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleSubmit(event) {
		const self = this;
		const { params, errors } = self.state.searchUserForm;
		let formError = false;
		//Reset all errors
		for(var key in errors) {
            if(!params[key.replace("Error","")]) {
                errors[key] = 'error';
                formError = true;
            } else {
				errors[key] = '';
			}
        }
		self.setState({
			params,
			errors
		});

		if(!formError) {
			const fitlerData = [];
			let assets = JSON.parse(JSON.stringify(self.props.state.homepage.assets));
			const { params: { accountType, assetType} } = self.state.searchUserForm;
			assets.responseObject.forEach(item => {
				if(item.assetType === assetType && item.customerType === accountType) {
					fitlerData.push(item);
				}
			});

			self.setState({
				showForm: true,
				assets: JSON.parse(JSON.stringify(fitlerData))
			});
		}
	}
	handleSearchUser(event) {
		event.preventDefault();
		const self = this;
		const { params, errors } = self.state.searchUserForm;
		let formError = false;
		//Reset all errors
		for(var key in errors) {
			if(!params[key.replace("Error","")]) {
				errors[key] = 'error';
				formError = true;
			} else {
				errors[key] = '';
			}
		}
		self.setState({
			params,
			errors,
			errorMessage: '',
			userDetailsData: null,
			showForm: false,
		}, () => {
			if(!formError) {
				// get local user details
				self.props.getOthersLocalUserDetails(`userId=${params.userName}&requestType=getLocalUser`, response => {
					if(response.status) {
						if(response.responseObject) {
							self.setState({
								userDetailsData: response.responseObject,
								userDetails: {
									params: {
										...self.state.userDetails.params,
										userId: response.responseObject.userId,
										firstName: response.responseObject.firstName,
										lastName: response.responseObject.lastName,
										emailId: response.responseObject.emailAddress,
									},
									errors: {
										emailIdError: '',
									}
								},
								showForm: true,
							});
						} else {
							self.setState({
								errorMessage: 'User name not found.'
							});
						}
					} else {
						self.setState({
							errorMessage: 'Error occured while fetching user details.'
						});
					}
				});
			}
		});
	}
	handleCancel(event) {
		event.preventDefault();
		browserHistory.push('/home');
	}
	handleCancelUpdateUser(event) {
		event.preventDefault();
		const self = this;
		self.setState({
			showForm: false,
		});
	}
	handleUpdateUser(formName, event) {
		event.preventDefault();
		const self = this,
            params = self.state[formName].params,
			errors = self.state[formName].errors;
        let formError = false;

        for(var key in errors) {
            if(params[key.replace("Error","")] === "" || !self.validateEmail(params[key.replace("Error","")])) {
                errors[key] = 'error';
                formError = true;
            } else {
				errors[key] = '';
			}
        }

		self.setState({
			[formName]: {
				params,
				errors
			}
		});
		if(!formError) {
			self.props.updateUserAccounts({}, `requestType=updateUserCNetEmail&userId=${params.userId}&emailId=${params.emailId}`, response => {
				if(response.status) {
					self.showEmailConfirmation('Email has been updated successfully.');
				} else {
					browserHistory.push("/error");
				}
			});
		}
	}
	showEmailConfirmation(msg) {
		const self = this;
		self.setState({
			genericDialogHeading: 'Success',
			genericDialogText: msg,
			modalButtons: 'ok',
		}, () => {
			self.handleDialog('EmailUpdateConfirmationDialog', true, null);
		});
	}
    render() {
		const self = this;
		const {
			state: {
				showForm,
				searchUserForm: {
					params: {
						userName,
					},
					errors: {
						userNameError,
					}
				},
				userDetails: {
					params,
					errors,
				}
			}
		} = self;
        return (
            <div>
				<div className="push">
					<h1 className="pageTitle">Manage User</h1>
				</div>
				<div className="largePush">
					<table className="createOrderTableA">
						<tbody>
							<tr>
								<td><strong>User Name</strong></td>
								<td>
									<input type="text" className={userNameError} name="userName" value={userName} onChange={this.updateParams.bind(this, 'searchUserForm')} />&nbsp;<input type="button" onClick={this.handleSearchUser.bind(this)} className="blueButton uppercase" defaultValue="Search" />
								</td>
							</tr>
							<tr>
								<td></td>
								<td><p className="bold red" id="errorMessage">{this.state.errorMessage}</p></td>
							</tr>
						</tbody>
					</table>
					{showForm && <div>
						<table className="formTableTypeA createOrderTableA">
							<tbody>
								<tr>
									<td className="text-left">First Name</td>
									<td>{params.firstName}</td>
								</tr>
								<tr>
									<td className="text-left">Last Name</td>
									<td>{params.lastName}</td>
								</tr>
								<tr>
									<td className="text-left">Email Id</td>
									<td><input type="text" placeholder="Enter email address" onChange={this.updateParams.bind(this, 'userDetails')} name="emailId" value={params.emailId} className={errors.emailIdError}/></td>
								</tr>
								<tr>
									<td />
									<td>
										<input type="button" onClick={this.handleCancelUpdateUser.bind(this)} className="blueButton uppercase" defaultValue="Cancel" />&nbsp;
			                            <input type="button" onClick={this.handleUpdateUser.bind(this, 'userDetails')} className="blueButton uppercase" defaultValue="Update" />
									</td>
								</tr>
							</tbody>
						</table>
					</div>}
				</div>
				{this.state.showEmailUpdateConfirmationDialog?<GenericOverlayDialog flag={'SavedBrochuresNotFoundOverlayDialog'} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getOthersLocalUserDetails: (payload, callback) => dispatch(getOthersLocalUserDetails(payload, callback)),
	updateUserAccounts: (payload, hybridQueryParams, callback) => dispatch(updateUserAccounts(payload, hybridQueryParams, callback)),
});

UpdateUser = connect(mapStateToProps, mapDispatchToProps)(UpdateUser);
export default UpdateUser;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/UpdateUser/index.js